(ns rothko.modal.component
  (:require [reagent.core :as reagent]
            [rothko.component.core :refer [defcomp]]
            [rothko.icon.component :refer [icon]]
            [rothko.panel.component :refer [panel]]))

(defn toggle-body-class
  []
  (.toggle (.. js/document -body -classList)
           "modal--open"))

(defcomp modal
  {:component-type ::modal}
  [props content]
  (reagent/create-class
   {:display-name "modal"
    :component-did-mount #(toggle-body-class)
    :component-will-unmount #(toggle-body-class)
    :reagent-render
    (fn [{:keys [appearance dismissable? on-close open? title] :as props} content]
      [:div.modal {:class appearance}
       content
       [:div.modal__background (when dismissable?
                                 {:class [:modal__background--dismissable]
                                  :on-click #(on-close)})]])}))
